import { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { SkipForward, Volume2 } from "lucide-react";
import { Logo } from "../brand/Logo";

export const INTRO_SEEN_KEY = "hpf_intro_seen";
const SRC = "/intro/intro-presentadora.mp4";

/** Video de bienvenida a pantalla completa (presentadora IA). Se muestra una vez por dispositivo o al pedir "Ver intro". */
export const IntroOverlay = ({ open, onClose }) => {
  const videoRef = useRef(null);
  const [needsTap, setNeedsTap] = useState(false);

  useEffect(() => {
    if (!open) return;
    const v = videoRef.current;
    if (!v) return;
    v.muted = false;
    v.currentTime = 0;
    const p = v.play();
    p?.catch(() => setNeedsTap(true)); // el navegador bloquea el autoplay con sonido hasta un toque
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const finish = () => {
    localStorage.setItem(INTRO_SEEN_KEY, "1");
    videoRef.current?.pause();
    onClose();
  };
  const startWithSound = () => {
    setNeedsTap(false);
    const v = videoRef.current;
    v.muted = false;
    v.play().catch(() => {});
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.5 }} className="fixed inset-0 z-[100] flex flex-col bg-ink" data-testid="intro-overlay">
          <div className="absolute left-5 top-5 z-10 sm:left-8 sm:top-7"><Logo tone="light" className="h-8 sm:h-9" testId="intro-logo" /></div>
          <video ref={videoRef} src={SRC} poster="/intro/intro-poster.jpg" playsInline preload="auto" onEnded={finish} className="h-full w-full object-contain" data-testid="intro-video" />
          {needsTap && (
            <button type="button" onClick={startWithSound} className="absolute inset-0 z-10 grid place-items-center bg-ink/60 backdrop-blur-sm" data-testid="intro-tap-to-play">
              <span className="inline-flex items-center gap-3 rounded-full bg-leaf px-7 py-4 font-display text-base font-semibold text-ink shadow-2xl sm:text-lg"><Volume2 className="h-5 w-5" /> Tocar para escuchar la bienvenida</span>
            </button>
          )}
          <div className="pointer-events-none absolute inset-x-0 bottom-0 z-10 flex justify-center bg-gradient-to-t from-ink/90 to-transparent px-6 pb-8 pt-20">
            <button type="button" onClick={finish} className="pointer-events-auto inline-flex items-center gap-2 rounded-full border border-white/30 bg-white/10 px-6 py-3 font-mono text-xs uppercase tracking-[0.14em] text-white backdrop-blur transition-colors hover:border-leaf hover:text-leaf" data-testid="intro-skip">
              Saltar intro <SkipForward className="h-4 w-4" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
